<div class="invite-list">
  <div class="invite-list__title">
    <h2 translate>OFFENE EINLADUNGEN</h2>
  </div>
  <div class="invite-list__content" *ngIf="(openInvites$ | async)?.length > 0; else noinvites">
    <app-invite-item *ngFor="let invite of openInvites$ | async" [item]="invite"></app-invite-item>
  </div>

  <div class="invite-list__title">
    <h2 translate>ANGENOMMENE EINLADUNGEN</h2>
  </div>
  <div class="invite-list__content">
    <ng-container *ngIf="(acceptedInvites$ | async)?.length > 0">
      <app-invite-item *ngFor="let invite of acceptedInvites$ | async" [item]="invite"></app-invite-item>
    </ng-container>
    <div class="invite-list__buttons">
      <button class="invite-list__button" id="invite" mat-flat-button color="primary" (click)="invite()" translate>
        Jetzt einladen
      </button>
    </div>
  </div>

  <ng-template #noinvites>
    <div class="invite-list__content">
      <img src="assets/img/illu_noinvites.png" style="display: block; margin-left: auto; margin-right: auto" />
      <p style="text-align: center" data-test-ide="invite_list_no_invites">Es sind noch keine Einladungen vorhanden</p>
    </div>
  </ng-template>
</div>
